/**
 * Protected Route Component Redirects unauthenticated users to login page.
 */

import Box from "@cloudscape-design/components/box"
import Spinner from "@cloudscape-design/components/spinner"
import { Navigate, useLocation } from "react-router-dom"
import { useAuth } from "../../contexts/AuthContext"
import { buildLoginUrl } from "../../utils/redirect"

interface ProtectedRouteProps {
  children: React.ReactNode
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <Box textAlign="center" padding="l">
        <Spinner size="large" nativeAttributes={{ role: "progressbar", "aria-label": "Loading" }} />
      </Box>
    )
  }

  if (!user || !user.isAuthenticated) {
    // Carry the page they asked for, fragment included, so sign-in lands them back on it.
    return (
      <Navigate to={buildLoginUrl(location.pathname + location.search + location.hash)} replace />
    )
  }

  return <>{children}</>
}
